import type { License } from '../../types'

interface LicensesStatsSummaryProps {
  licenses: License[]
}

interface StatCardProps {
  label: string
  value: string
  valueClass?: string
}

function StatCard({ label, value, valueClass }: StatCardProps): React.ReactElement {
  const finalValueClass = valueClass ?? 'text-stone-900 dark:text-stone-100'
  return (
    <div className="rounded-lg border border-stone-200 bg-white p-4 dark:border-stone-700 dark:bg-stone-800">
      <p className="text-sm text-stone-500 dark:text-stone-400">{label}</p>
      <p className={`text-2xl font-semibold ${finalValueClass}`}>{value}</p>
    </div>
  )
}

export function LicensesStatsSummary({ licenses }: LicensesStatsSummaryProps): React.ReactElement {
  const activeCount = licenses.filter(
    (license) => license.status === 'active' && license.isValid
  ).length
  const suspendedCount = licenses.filter((license) => license.status === 'suspended').length
  const seatsUsed = licenses.reduce((sum, license) => sum + license.seatsUsed, 0)
  const seatsTotal = licenses.reduce((sum, license) => sum + license.seatsTotal, 0)
  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
      <StatCard label="Total Licenses" value={String(licenses.length)} />
      <StatCard
        label="Active"
        value={String(activeCount)}
        valueClass="text-green-600 dark:text-green-400"
      />
      <StatCard
        label="Suspended"
        value={String(suspendedCount)}
        valueClass="text-amber-600 dark:text-amber-400"
      />
      <StatCard label="Total Seats" value={`${String(seatsUsed)}/${String(seatsTotal)}`} />
    </div>
  )
}
